import { ApiUtils } from '@/utils/ApiUtils'
import { resetState } from '@/utils/Storage'

const initialState = ()=> {
  return  {
    creatingQuotation: false
  }
}

export default {
  namespaced: true,
  state: {
    creatingQuotation: false
  },
  mutations: {
    reset: (state) => {
      const s = initialState()
      resetState(state, s);
    },
    creatingQuotation(state, payload) {
      state.creatingQuotation = payload
    }
  },
  actions: {
    async initialLoad(ctx, payload) { //url, itemURL
      try {
        const request = await ApiUtils.makeGet(payload.url)
        const response = await request.json()
        const quoteData = response.result[payload.itemURL]

        const pageData = await ctx.dispatch('loadPageData', {raw: quoteData, actual: []})
        if (response.ok || response.code === 200) {
          const services = await ctx.dispatch('loadServices', {quotations: quoteData.data, services: []})
          return {ok: true, pageData, services}
        }
        return {ok: false, quotations: null}
      } catch (error) {

      }
    },
    async loadNextPage(ctx, payload) { // nextPageUrl, itemURL, actual
      const next = payload.nextPageUrl.split('/v1/')[1]
      const request = await ApiUtils.makeGet(next)
      const response = await request.json()
      const quoteData = response.result[payload.itemURL]
      const finalize = await ctx.dispatch('loadPageData', {raw: quoteData, actual: payload.actual})
      return finalize
    },
    loadPageData(ctx, payload) { // raw, actual
      const quotations = payload.raw.data.map(item => {
        item.date = new Date(item.created_at).getTime()
        item.quoted = !!item.quotation
        return item
      })
      const all = [...payload.actual, ...quotations]
      return {
        quotations: all,
        currentPage: payload.raw.current_page,
        totalItems: payload.raw.total,
        nextPageUrl: payload.raw.next_page_url
      }
    },
    loadServices(ctx, payload) { // services, quotations
      const all = []
      payload.quotations.forEach(quote => {
        if (quote.special_sale) {
          all.push(quote.special_sale.service_item.description)
        } else {
          quote.service_items.forEach(item => {
            all.push(item.description)
          })
        }
      })
      const services = [...payload.services, ...all]
      return Array.from(new Set(services))
    },
    async loadProviderServices(ctx, payload) { // providerId
      let id = null
      if (payload && payload.providerId)
        id = payload.providerId
      else
        id = ctx.rootState.currentProvider.id
      const url = `provider/${id}/services/attached`
      const request = await ApiUtils.makeGet(url)
      const response = await request.json()
      const services = response.result.services
      const servicesItems = []
      services.forEach(service => {
        service.service_items.forEach(item => {
          if (item)
            servicesItems.push({
              serviceId: service.id,
              serviceItemId: item.id,
              serviceName: service.name,
              description: item.description,
              fullName: `${service.name} | ${item.description}`,
              price: item.price,
              taxFree: !!item.tax_free
            })
        })
      })
      return servicesItems
    },
    async saveNewQuotation(ctx, payload) {
      const {
        email,
        dni,
        first_name,
        last_name,
        mother_last_name,
        phone1,
        phone2,
        commune_id,
        address,
        id
      } = payload.data.user
      const data = {
        quotation_request_id: payload.isFromTemplate
          ? payload.quotationSelected
          : null, //? request_id?
        discount: payload.isSpecialSale ? payload.data.items[0].discount : 0,
        client: {
          email,
          dni,
          first_name,
          last_name,
          mother_last_name,
          commune_id,
          address,
          id,
          phone1: checkPhone(phone1),
          phone2: checkPhone(phone2)
        },
        items: payload.data.items.map(item => {
          return {
            id: item.description.serviceItemId
              ? item.description.serviceItemId
              : null,
            qty: item.qty ? item.qty : 1,
            discount: item.discount ? item.discount : 0
          }
        }),
        comments: payload.data.comments,
        expiration_date: payload.data.expirationDate
      }
      try {
        ctx.commit('creatingQuotation', true)
        const url = `provider/${payload.providerId}/quotation`
        const response = await ApiUtils.makePost(url, data)
        const decoded = await response.json()
        if (response.ok || response.code === 200) {
          ctx.commit('showSnackBar', payload.successMessage, {root: true})
          return {ok: response.ok, payload: decoded.result.quotation}
        }
        ctx.commit('showSnackBar', 'Error', {root: true})
        return {ok: false, payload: null}
      } catch (error) {

        ctx.commit('showSnackBar', 'ERROR', {root: true})
        return {ok: false, payload: null}
      } finally {
        ctx.commit('creatingQuotation', false)
      }
    }
  },
  getters: {
    creatingQuotation: state => state.creatingQuotation
  }
}

function checkPhone(phone) {
  if (!phone) return '56000000000'
  const ph = phone.split('')
  const area = ph[0] + ph[1]
  if (area === '56' && ph.length < 12 && ph.length >= 10) 
    return phone
  return '56' + phone
}